export class GetDevOpsActionsRequest {
    customerId?: string;
    accountId?: string;
    environmentId?: string;
    region?: string;
}